import dayjs from 'dayjs'

export default {
    transform(data) {
        return JSON.parse(data).reduce((dates, { date, slotCount }) => {
            dates[dayjs(date).startOf('day').format()] = { slotCount }
            return dates
        }, {})
    },
}
